export const seasonalPerks = [
  { check: true, label: 'Seasonal Box: 8–10 products valued at $200+', additionalLabel: '' },
  { check: true, label: 'Customize your box', additionalLabel: 'Customize some of your box' },
  { check: true, label: 'Members Only Sales', additionalLabel: '' },
  { check: true, label: 'FabFitFun TV', additionalLabel: '' },
  { check: true, label: 'The Community Forum', additionalLabel: '' },
  { check: false, label: 'More box customization options each season', additionalLabel: '' },
  { check: false, label: 'Early access to member\'s only sales', additionalLabel: '' },
  { check: false, label: 'Earlier shipping with our first billing/shipping date', additionalLabel: '' },
];
export const annualPerks = [
  { check: true, label: 'The Seasonal Box ', additionalLabel: '' },
  { check: true, label: 'Customize your box ', additionalLabel: 'Customize some of your box' },
  { check: true, label: 'Members Only Sales', additionalLabel: '' },
  { check: true, label: 'FabFitFun TV', additionalLabel: '' },
  { check: true, label: 'The Community Forum', additionalLabel: '' },
  { check: true, label: 'More box customization options each season', additionalLabel: '' },
  { check: true, label: 'Early access to member\'s only sales', additionalLabel: '' },
  { check: true, label: 'Earlier shipping with our first billing/shipping date', additionalLabel: '' },
];

export const additionalPerks = [
  { check: true, label: 'Unlimited Swap for Credit' },
];

export const SEASONAL = 'SEASONAL';

export const planDisclaimer = {
  SEASONAL: (
    'By clicking below, you will be charged $49.99* '
    + 'for the seasonal subscription. Auto-renew seasonally, cancel anytime.'
  ),
  ANNUAL: (
    'By clicking below, you will be charged $179.99* '
    + 'for 4 boxes. Subscription will auto-renew after 4 seasonal cycles. Cancel anytime.'
  ),
};
